import { Year } from "../../models/Year"

const mutations = {
  addYear(state: any, year: Year) {
    state.list.push(year);
  },
  loading(state: any, loading: boolean) {
    state.loading = loading
  },
  resetYearList(state: any) {
    state.list = []
  }
}

const getters = {
  loading(state: any) {
    return state.loading
  },
  yearsForMake(state: any) {
    return state.list
  }
}

const actions = {
  async reloadYears(context: any, args: any) {
    context.commit('loading', true)
    context.commit('resetYearList')

    const years : Year[] = await Year.getYearsForMake(args.makeId)
    years.forEach((year : Year) => {
      context.commit('addYear', year)
    })

    context.commit('loading', false)

    return Promise.resolve()
  },
}

const state = () => ({
  list: [] as Year[],
  loading: false
})

export default {
  namespaced: true,
  mutations,
  getters,
  state,
  actions,
};
